import {sample} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {fetchDataFx, commonData$, DocumentsDetailGate} from './index';

commonData$.on(fetchDataFx.done, (state, {result}) => result).reset(DocumentsDetailGate.close);

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));

sample({
    clock: DocumentsDetailGate.open,
    source: DocumentsDetailGate.state,
    fn: (state) => state.id,
    target: fetchDataFx,
});
